module.exports = __webpack_public_path__ + "img/company4.671caeed.png";